module.exports = __webpack_public_path__ + "img/vertical-resizer.85902df2.svg";